import {
    isAdditionalPaymentCheckoutFlow,
    type CheckoutFlow,
} from './checkout-paths'
import type { StripeCheckoutUiMode } from './stripe-checkout'

export function shouldUseDirectCheckoutStart(
    checkoutFlow: CheckoutFlow,
    checkoutUiMode: StripeCheckoutUiMode,
): boolean {
    return isAdditionalPaymentCheckoutFlow(checkoutFlow) && checkoutUiMode !== 'embedded'
}
